import styled, {ThemeContext} from 'styled-components';
import React from 'react';
import ActionComponent from '../api/ActionComponent';
class Fornecedores extends ActionComponent {
    constructor(props) {
        super(props)
    }

    componentDidMount(){

        this.setState({
            apiUrl:'produtos'
        }, () => this.buscar());
        
    }

    render(){
        console.log(this.state)
        return(
        <>
            <p>Em Produção</p>
        </>
        )
    }
}

export default Fornecedores;